import { ca } from '@cian/analytics';

export type TFavoriteEventSource = 'about_building';

// Добавление ЖК в избранное
export function trackAddToFavorites(
  gaLabel: string,
  newbuildingId: number,
  action?: string,
  source?: TFavoriteEventSource,
) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: action || 'add_from_card_JK',
    label: gaLabel,
    oid: newbuildingId,
    useLastProducts: true,
    ...(source && { page: { extra: { source } } }),
  });
}

// Удаление ЖК из избранного
export function trackRemoveFromFavorites(
  gaLabel: string,
  newbuildingId: number,
  action?: string,
  source?: TFavoriteEventSource,
) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: action || 'remove_from_card_JK',
    label: gaLabel,
    oid: newbuildingId,
    useLastProducts: true,
    ...(source && { page: { extra: { source } } }),
  });
}
